import React, { useState, useEffect, useContext } from "react";
import { FaSearch } from "react-icons/fa";
import { Route, useNavigate, useParams } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../Files/BaseURL";
import ThemeContext from "../../../../Context/theme/ThemeContext";
import axios from "axios";

const RecivedRequests = () => {
  // 1. Context hooks
  const { theme } = useContext(ThemeContext);
  const { showAlert } = useContext(AlertContext);
  const navigate = useNavigate();
  const { jobId } = useParams();

  // 2. State hooks
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResponses, setTotalResponses] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  // 3. Helper functions
  const formatDate = (timestamp) => {
    const dateObj = new Date(timestamp);
    const month = dateObj.toLocaleString("en-US", { month: "short" });
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${day} ${month}`;
  };

  // Function to fetch responses with server-side pagination
  const fetchResponses = async (page = currentPage) => {
    const authToken = localStorage.getItem("p@token");
    try {
      setLoading(true);
      const response = await fetch(
        `${BaseURL}/api/requestjob/getResponses/${jobId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
          params: {
            page: page,
            limit: itemsPerPage,
            search: searchTerm,
          },
        }
      );

      if (!response.ok) {
        showAlert("Error fetching job details", "danger");
        return;
      }

      const data = await response.json();
      if (data.success) {
        setResponses(data.responses);
        setTotalPages(data.pagination.totalPages);
        setTotalResponses(data.pagination.totalResponses);
      } else {
        showAlert(data.message || "Error fetching responses", "danger");
      }
    } catch (error) {
      showAlert("Network Error", "danger");
    } finally {
      setLoading(false);
    }
  };

  // Fetch responses when component mounts or search term changes
  useEffect(() => {
    setCurrentPage(1); // Reset to first page when filters change
    fetchResponses(1);
  }, [jobId, searchTerm, itemsPerPage]);

  // Fetch responses when page changes
  useEffect(() => {
    fetchResponses(currentPage);
  }, [currentPage]);

  // Update search input
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // 4. Request closing handler
  const closeRequest = async () => {
    try {
      const response = await axios.put(
        `${BaseURL}/api/requestjob/closeRequest/${jobId}`,
        [],
        {
          headers: {
            "auth-token": localStorage.getItem("p@token"),
          },
        }
      );

      if (response.status === 200) {
        showAlert("Request Closed Successfully", "success");
      } else {
        showAlert("Failed to close request", "danger");
      }
    } catch (error) {
      console.error(error);
      showAlert("Error closing request", "danger");
    }
  };

  // 5. Calculate pagination data
  const paginatedResponses = loading
    ? []
    : responses.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

  // 8. Loading state
  if (loading) {
    return <div>Loading...</div>;
  }

  // 9. Main render
  return (
    <div>
      <div className="flex flex-col gap-4 lg:flex-row justify-between font-pop lg:items-center">
        <div className="flex flex-col md:flex-row gap-2 md:gap-6 md:items-center">
          <h3
            className={`text-gray-400 text-sm md:text-lg font-medium ${
              theme == "dark" && "text-white"
            }`}
          >
            Total {totalResponses} Offers
          </h3>
          <div
            className={` rounded-2xl px-1 md:px-3 ${
              theme == "dark" ? "bg-black text-white" : "bg-gray-300 "
            }`}
          >
            <select
              name=""
              id=""
              className={` border-none outline-none  focus:outline-none focus:border-none w-full focus:outline-transparent active:border-none active:outline-none text-sm md:text-lg font-normal ${
                theme == "dark" ? "bg-black text-white" : "bg-gray-300"
              } `}
            >
              <option value="">All Category</option>
              <option value="">All Offers</option>
              <option value="">All Offers</option>
              <option value="">All Offers</option>
            </select>
          </div>
          <div
            className={` rounded-2xl px-1 md:px-3 ${
              theme == "dark" ? "bg-black text-white" : "bg-gray-300 "
            }`}
          ></div>
        </div>

        <div className={`flex gap-3 items-center px-4`}>
          <button
            className="my-4 w-fit px-2 md:px-6 bg-green-500 hover:bg-transparent hover:bg-white-500 font-semibold hover:text-black font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  text-white"
            onClick={closeRequest}
          >
            Close Request
          </button>

          <div
            className={`flex gap-3 items-center  rounded-full py-1 px-4 ${
              theme == "dark" ? "bg-black text-white" : "bg-gray-300 "
            }`}
          >
            <FaSearch className="text-gray-400 text-lg md:text-2xl" />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearch}
              className={`text-sm md:text-lg border-none outline-none focus:outline-none focus:border-none active:outline-none 
              ${theme == "dark" ? "bg-black text-white" : "bg-gray-300"}`}
            />
          </div>
        </div>
      </div>
      <div className=" overflow-x-scroll font-pop w-full my-2 md:my-6">
        <table
          className={`w-full overflow-x-scroll border-spacing-y-4 border-separate
        ${theme == "dark" && " text-white"}  `}
        >
          <thead>
            <tr>
              {/*         <th*/}
              {/*             scope="col"*/}
              {/*             className={`px-3 md:px-6 py-1 md:py-3 text-left font-medium uppercase */}
              {/*`}*/}
              {/*         >*/}

              {/*         </th>*/}
              <th
                scope="col"
                className={`px-3 md:px-6 py-1 md:py-3 text-left w-[30%] font-medium uppercase
               `}
              >
                User
              </th>
              <th
                scope="col"
                className={`px-3 md:px-6 py-1 md:py-3 text-left font-medium  uppercase`}
              >
                Rating
              </th>
              <th
                scope="col"
                className={`px-3 md:px-6 py-1 md:py-3 text-left font-medium uppercase`}
              >
                Price
              </th>
              {/*<th*/}
              {/*    scope="col"*/}
              {/*    className={`px-3 md:px-6 py-1 md:py-3 text-left font-medium uppercase`}*/}
              {/*>*/}
              {/*    User*/}
              {/*</th>*/}
              <th
                scope="col"
                className={`px-3 md:px-6 py-1 md:py-3 text-left font-medium  uppercase`}
              >
                Delivery date
              </th>
            </tr>
          </thead>
          {paginatedResponses.length === 0 && <div>No Data Available</div>}
          <tbody>
            {paginatedResponses?.map((response, index) => (
              <tr
                key={index}
                onClick={() => {
                  navigate(
                    `/user-dashboard/offers/my-job-requests/user-info/${jobId}/${response.user._id}`
                  );
                }}
                className="cursor-pointer"
              >
                {/*         <td*/}
                {/*             className={`px-2 md:px-6 my-3 py-1 md:py-3 rounded-l-xl*/}
                {/*${theme === "dark" ? "bg-black text-white" : "bg-white"}`}*/}
                {/*         >*/}
                {/*             <div className={'rounded-full bg-primarygreen w-7 flex items-center justify-center '}>*/}
                {/*                 <h2 className=""></h2>*/}
                {/*             </div>*/}
                {/*         </td>*/}
                <td
                  className={`px-2 md:px-6 my-3 text-base md:text-lg font-semibold py-3 text-left w-max min-w-[30%] rounded-l-xl
                   ${theme == "dark" ? "bg-black text-white" : "bg-white "}`}
                >
                  <div
                    className={`flex gap-2 items-center ${
                      theme == "dark" ? "bg-black text-white" : "bg-white "
                    } `}
                  >
                    {response.user.ProfilePhoto ? (
                      <img
                        src={response.user.ProfilePhoto}
                        alt=""
                        className="rounded-full w-8 md:w-12 h-8 md:h-12"
                      />
                    ) : (
                      <div className="w-8 md:w-12 h-8 md:h-12 rounded-full font-pop bg-gray-400 flex items-center justify-center">
                        <span className={`text-white `}>
                          {response.user && response.user?.FirstName?.charAt(0)}
                        </span>
                      </div>
                    )}

                    <h2 className="w-max">
                      {response.user.FirstName} {response.user.LastName}
                    </h2>
                  </div>
                </td>
                <td
                  className={`px-2 md:px-6 my-3 py-1 md:py-3 font-normal text-left
                   ${theme == "dark" ? "bg-black text-white" : "bg-white "}`}
                >
                  <h2 className="w-max">{response.user.Rating.toFixed(1)}</h2>
                </td>
                <td
                  className={`px-2 md:px-6  my-3 py-1 md:py-3 text-left font-semibold 
                   ${theme == "dark" ? "bg-black text-white" : "bg-white "}`}
                >
                  <h2 className="w-max">${response.amount}</h2>
                </td>
                {/*         <td*/}
                {/*             className={`px-2 md:px-6 my-3 py-1 md:py-3 font-normal text-left*/}
                {/*${theme == "dark" ? "bg-black text-white" : "bg-white "}`}*/}
                {/*         >*/}
                {/*             <div*/}
                {/*                 className={`flex gap-2 items-center font-semibold ${theme == "dark" ? "bg-black text-white" : "bg-white "} `}>*/}
                {/*                 <img*/}
                {/*                     src={response.user.ProfilePhoto}*/}
                {/*                     alt="Profile"*/}
                {/*                     className="rounded-full w-8 md:w-12 h-8 md:h-12"*/}
                {/*                 />*/}
                {/*                 <h2 className="w-max">{response.user.FirstName} {response.user.LastName}</h2>*/}
                {/*             </div>*/}
                {/*         </td>*/}

                <td
                  className={`px-2 md:px-6 rounded-r-2xl text-gray-400 my-3 py-1 md:py-3 text-left 
                   ${theme == "dark" ? "bg-black text-white" : "bg-white "}`}
                >
                  <h2 className="w-max">{formatDate(response.date)}</h2>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {responses.length > 0 && (
        <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 mt-4 rounded-lg">
          <div className="flex flex-1 justify-between sm:hidden">
            {/* Mobile view */}
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
                currentPage === 1
                  ? "bg-gray-100 text-gray-400"
                  : "bg-white text-gray-700 hover:bg-gray-50"
              } ring-1 ring-inset ring-gray-300 rounded-md`}
            >
              Previous
            </button>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className={`relative ml-3 inline-flex items-center px-4 py-2 text-sm font-semibold ${
                currentPage === totalPages
                  ? "bg-gray-100 text-gray-400"
                  : "bg-white text-gray-700 hover:bg-gray-50"
              } ring-1 ring-inset ring-gray-300 rounded-md`}
            >
              Next
            </button>
          </div>

          {/* Desktop view */}
          <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
            {/* Left side - Items per page */}
            <div>
              <div className="flex items-center gap-4 font-bold font-pop text-xs">
                <select
                  value={itemsPerPage}
                  onChange={(e) => setItemsPerPage(Number(e.target.value))}
                  className="block w-20 rounded-md border-0 py-1.5 pl-3 pr-8 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primarygreen sm:text-sm sm:leading-6"
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <p className="text-sm text-gray-700">items per page</p>
              </div>
            </div>

            {/* Center - Items count */}
            <div className="font-pop text-xs font-bold">
              <p className="text-sm text-gray-700">
                {`${(currentPage - 1) * itemsPerPage + 1}-${Math.min(
                  currentPage * itemsPerPage,
                  totalResponses
                )} of ${totalResponses} items`}
              </p>
            </div>

            {/* Right side - Navigation and pages */}
            <div className="flex items-center gap-4 font-bold font-pop text-xs">
              <div className="flex items-center gap-2">
                <p className="text-sm text-gray-700">Page</p>
                <p className="text-sm font-bold text-gray-900">{currentPage}</p>
                <p className="text-sm text-gray-700">of</p>
                <p className="text-sm font-bold text-gray-900">{totalPages}</p>
                <p className="text-sm text-gray-700">pages</p>
              </div>
              <nav
                className="isolate inline-flex -space-x-px rounded-md shadow-sm"
                aria-label="Pagination"
              >
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                  className={`relative inline-flex items-center rounded-l-md px-2 py-2 ${
                    currentPage === 1
                      ? "bg-gray-100 text-gray-400"
                      : "bg-white text-gray-500 hover:bg-gray-50"
                  } ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                >
                  <span className="sr-only">Previous</span>
                  <svg
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>

                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                  className={`relative inline-flex items-center rounded-r-md px-2 py-2 ${
                    currentPage === totalPages
                      ? "bg-gray-100 text-gray-400"
                      : "bg-white text-gray-500 hover:bg-gray-50"
                  } ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0`}
                >
                  <span className="sr-only">Next</span>
                  <svg
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </nav>

              {/* Pages display */}
            </div>
          </div>
        </div>
      )}

      {/* Show no data message */}
      {responses.length === 0 && (
        <div className="text-center py-4 font-pop text-lg font-medium">No offers found</div>
      )}
    </div>
  );
};

export default RecivedRequests;
